<template>
  <div>
      <ul>
        <li 
        v-for="(message, i) in messages"
        :key="i"
        >
            {{ message }}
        </li>
    </ul>
  </div>
</template>

<script>
export default {
name: 'test',
  data: () => ({ messages: ['Hey John', 'Howdy Paco'] }),
}
</script>

<style>

</style>